import { connect } from "react-redux";
import { validatePermission } from "utils/permissionHelper";
import rules from "../../rbac-rules";

const mapStateToProps = state => ({ usuario: state.auth.usuario });

const check = (action, data, usuario) => {
	const permissions = rules.default;
	if (!permissions) {
		// role is not present in the rules
		return false;
	}

	const userPermissions = usuario.soeAcoes;
	if (
		userPermissions &&
		action &&
		validatePermission(action, userPermissions)
	) {
		// static rule not provided for action
		return true;
	}
	return false;
};

const Can = props =>
	check(props.perform, props.data, props.usuario) ? props.yes() : props.no();

Can.defaultProps = {
	yes: () => null,
	no: () => null
};

export default connect(mapStateToProps)(Can);
